import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2026" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <div className="entry-content">


            <h2>Transportation Facilities in Chengdu</h2>
            <br></br>



            <h3>Chengdu Shuangliu International Airport</h3>
            <br />

            <p>
              <div className="title-center"
              >
                <img
                  src="./images/transportation/shuangliu.jpg"
                  width={800}
                />

              </div>
            </p>
            <br />
            <p>
              Chengdu Shuangliu International Airport (IATA: CTU, ICAO: ZUUU) is located at the border of Shuangliu District and Wuhou District in Chengdu, Sichuan Province, China, approximately 16 kilometers northeast of downtown Chengdu. It is a 4F-class international airport and international aviation hub, one of China&apos;s eight major regional hub airports.
              <br></br>
              <br></br>
              Chengdu Shuangliu Airport officially opened in May 1957 as a reconstruction of the Air Force Shuangguisi Airport. It was renamed Chengdu Shuangliu International Airport on November 30, 1995. As of November 2024, the airport features a T1 terminal building covering 150,000 square meters and a T2 terminal building covering 350,000 square meters. The civil aviation apron has 228 aircraft positions, including 74 jetbridge positions. It has two runways: the north runway is 3,600 meters long and 45 meters wide, while the south runway is 3,600 meters long and 60 meters wide. The airport can handle 60 million passengers and 1.3 million tons of cargo annually. In 2023, Chengdu Shuangliu International Airport handled 30.138 million passengers (ranked 12th nationally) and 527,000 tons of cargo (ranked 7th nationally).
            </p>

            <p>
              For more information, please visit{" "}
              <a href="https://www.cd-airport.cn/">https://www.cd-airport.cn/</a>
            </p>

            <p>&nbsp;</p>
            <h3>Chengdu Tianfu International Airport</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/transportation/tianfu.jpg"
                width={800}
              />

            </div>
            <p>
              <br />
              Chengdu Tianfu International Airport (IATA: TFU, ICAO: ZUTF) is located in Lujia Town, Jianyang City, Chengdu, Sichuan Province, approximately 51 kilometers from downtown Chengdu. It officially began operations on June 27, 2021. Tianfu Airport is Chengdu&apos;s second international airport, forming the Chengdu International Aviation Hub together with Shuangliu Airport.
              <br></br>
              <br></br>

              Chengdu Tianfu International Airport is built to 4F-class standards, featuring two terminal buildings and multiple runways. It primarily handles international and regional routes, domestic trunk routes, and transit services. The airport adopts a &apos;hand-in-hand&apos; configuration design and features the world&apos;s largest single satellite terminal. Tianfu Airport operates in &apos;dual-airport integration&apos; with Shuangliu Airport, connecting to the city center via Metro Line 18 and Line 19, serving as an important aviation hub in Southwest China and a key gateway for westward opening under the &apos;Belt and Road&apos; Initiative.
            </p>

            <p>
              Transportation Options:
              <br />
              • Metro Line 18: Direct service from South Railway Station to Tianfu Airport, approximately 30 minutes
              <br />
              • Airport Express Bus: Multiple routes connecting major locations in the city center
              <br />
              • Taxi: Approximately 50 minutes from city center, cost around 100 RMB
            </p>

            <p>&nbsp;</p>
            <h3>High-Speed Rail (High-Speed Train / Bullet Train)</h3>
            <br />
            <div className="title-center">
              <img
                src="./images/backgroud/gaotie.jpg"
                alt="High-Speed Rail"
                width={800}
              />
            </div>
            <p align="justify">
              <br />
              Chengdu is a major railway hub in southwestern China with an extensive high-speed rail (HSR) network connecting the city to many other cities across China. Modern high-speed trains offer fast, comfortable travel between Chengdu and destinations such as Chongqing, Xi&apos;an, Beijing, Shanghai, Kunming and more, making rail travel a convenient option for conference participants. High-speed trains operate from several major railway stations in the city and can reach speeds up to 350 km/h.
            </p>

            <p align="justify">
              <strong>Main High-Speed Train Stations:</strong><br />
              • <strong>Chengdu East Railway Station</strong> (成都东站) – the largest station handling most high-speed trains serving Chengdu and long-distance routes to/from other major cities.<br />
              • <strong>Chengdu South Railway Station</strong> (成都南站) – serves additional high-speed and intercity services.<br />
              • <strong>Chengdu West Railway Station</strong> and <strong>Chengdu Railway Station</strong> also operate trains to various regional destinations.
            </p>

            <p align="justify">
              Popular high-speed rail routes connected with Chengdu include the Chengdu–Chongqing intercity line (reducing travel time between Chengdu and Chongqing to around <strong>1–1.5 hours</strong>), and trains to Xi&apos;an taking roughly <strong>3–4.5 hours</strong> on the Xi&apos;an–Chengdu HSR.
            </p>

            <p align="justify">
              Many stations are integrated with Chengdu&apos;s metro system, making it easy to transfer between high-speed rail and urban transit or taxis when arriving in the city.
            </p>

            <p align="justify">
              For high-speed train schedules and ticket booking, visit the official China Railway ticketing site: <a href="https://www.12306.cn/" target="_blank" rel="noopener noreferrer">https://www.12306.cn/</a>
            </p>

          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | ICSI 2023" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
